module.exports = __webpack_public_path__ + "media/images/guide/anotacion/image8-cb906febba72bd7b588b8f8d21211201.png";